import {useQuery} from 'react-query';

import {
  IShopifyProductVariant,
  ShopifyProductVariantByIdDocument,
  ShopifyProductVariantByIdQueryVariables,
} from '~/lib/types/graphql/api';
import {queryBe} from '~/utils';

export function useShopifyProductVariant(
  input: ShopifyProductVariantByIdQueryVariables,
) {
  return useQuery(['shopify-product-variant', input.id], async () => {
    const {data} = await queryBe<
      'shopifyProductVariant',
      (id: string) => IShopifyProductVariant
    >({
      caller: 'client',
      query: ShopifyProductVariantByIdDocument,
      variables: {
        id: input.id,
      },
    });

    return data.shopifyProductVariant;
  });
}
